/* OG DEALS motion — minimal: scroll reveal + progress bar only */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function initReveal() {
    if (reduce) return;
    var sel = '.og-card, .og-stat, .og-cat, .og-store';
    var els = Array.prototype.slice.call(document.querySelectorAll(sel));
    if (!('IntersectionObserver' in window) || els.length === 0) return;
    els.forEach(function (el) {
      el.classList.add('og-reveal');
    });
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          io.unobserve(el);
          var idx = 0;
          if (el.parentElement) {
            var sibs = Array.prototype.slice.call(el.parentElement.children).filter(function (c) {
              return c.classList && c.classList.contains('og-reveal');
            });
            idx = Math.max(0, sibs.indexOf(el));
          }
          el.style.transitionDelay = Math.min(idx * 60, 240) + 'ms';
          el.classList.add('og-in');
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -30px 0px' }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  function initProgress() {
    var bar = document.createElement('div');
    bar.className = 'og-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var ticking = false;
    function upd() {
      var h = document.documentElement;
      var max = h.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      bar.style.transform = 'scaleX(' + p + ')';
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(upd);
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', upd);
    upd();
  }

  onReady(function () {
    initReveal();
    initProgress();
  });
})();
